export default __webpack_public_path__ + "static/media/DunbarText-Regular.b6921c54.woff";